<div class="tab-container">
  <lib-button [cssType]="'btn-secondary'"  [text]="'Download Policy Bundle'" [size]="'small'"  (click)="downloadPolicyBundle()"></lib-button>
  <lib-ui-grid [(gridOptions)]="gridOptions" (actionEvent)="actionEvent($event)"></lib-ui-grid>
</div>
